// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"a514d1c9","496":"cd7a6766","568":"586e080b","787":"56b06d95"}[chunkId] + ".chunk.js";
};